<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox">
      <div class="content">
        <div class="title f16">
          <span>搜索</span>
        </div>
        <div class="input">
          <van-search
            clearable
            @clear="clear()"
            v-model="value"
            placeholder="请输入选手编号或名称"
          />
        </div>
        <div class="searchBtn">
          <van-button
            @click="gotoVote()"
            type="primary"
            :style="{ background: '#fff', color: '#3c8efd' }"
            >关闭</van-button
          >
          <van-button @click="gotoVote()" type="primary" class="searchBtns"
            >搜索</van-button
          >
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close">
      <van-icon @click="close()" name="close" />
    </div>
  </div>
</template>

<script>
import searchMixin from "@/mixins/search.js";
export default {
  mixins: [searchMixin],
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem("info")),
    };
  },
};
</script>

<style lang="less" scoped>
.search {
  width: 10rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 10rem;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox {
    width: 9.2rem;
    height: 5rem;
    box-sizing: border-box;
    position: relative;
    .content {
      width: 94%;
      background: #fff;
      position: absolute;
      bottom: .2666667rem;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 0.08rem;
      .title {
        color: #3c8efd;
        text-align: center;
        margin-top: .8rem;
        position: relative;
      }
      .title::after {
        content: "";
        background: url("@/assets/banking/search-ornament.png");
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 1.4rem;
        width: 2.17rem;
        height: .39rem;
      }
      .title::before {
        content: "";
        background: url("@/assets/banking/search-ornament.png");
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        right: 1.4rem;
        width: 2.17rem;
        height: .39rem;
        transform: rotate(180deg);
      }
      .input {
        margin: .8rem 0 .8rem;
        .van-search {
          background: #fff;
          border: 0.05rem solid #3b8eff;
          padding: 0;
          margin: 0 .4666667rem;
          border-radius: 0.08rem;
          height: .8rem !important;
        }
        .van-search__content {
          border-radius: 0.4rem !important;
        }
        .van-cell {
          background-color: #fff;
          height: .7rem !important;
          padding: 3px 8px 5px 0 !important;
        }
      }
      .searchBtn {
        height: .96rem;
        width: 100%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(2, 50% 50%);
        border-top: 0.01rem solid #3c8efd;
        .searchBtns {
          background: linear-gradient(
            180deg,
            #65a6ff 0%,
            #66a7ff 13%,
            #3b8eff 92%,
            #71adff 100%
          ) !important;
        }
        .van-button {
          width: 100%;
          height: 100%;
          background: #c7171e;
          border: none;
        }
      }
    }
  }
  div.close {
    margin-top: .5333333rem;
    .van-icon-close {
      font-size: .96rem;
      color: #fff;
    }
  }
}
</style>